import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "helpers";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
    fetchBaseQuery({
        baseUrl: getAPIURL("/api/pvsa/form-rule-conditions"),
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.accessToken;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })
);

export const formRuleConditionsApi = createApi({
    reducerPath: "formRuleConditionsApi",
    baseQuery: baseQueryWithRejection,
    tagTypes: ["FormRules"],
    endpoints: (builder) => ({
        getFormRuleConditions: builder.query({
            query: ({formId, groupId}) => `/?form-id=${formId}&group-id=${groupId}`,
            transformResponse: (response) => response.data,
            providesTags: ["FormRules"],
        }),
        createFormRuleCondition: builder.mutation({
            query: (obj) => ({
                url: `/`,
                method: "POST",
                body: obj,
            }),
            invalidatesTags: ["FormRules"],
        }),
        updateFormRuleCondition: builder.mutation({
            query: (obj) => ({
                url: `/${obj.id}`,
                method: "PUT",
                body: obj,
            }),
            invalidatesTags: ["FormRules"],
        }),
        deleteFormRuleCondition: builder.mutation({
            query: (id) => ({
                url: `/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["FormRules"],
        }),
        updateAllFormRuleConditionOperations: builder.mutation({
            query: (obj) => ({
                url: `/update-all-operations`,
                method: "POST",
                body: {
                    group_id: obj.groupId,
                    operation: obj.operation,
                },
            }),
            invalidatesTags: ["FormRules"],
        }),
    }),
});

export const {
    useGetFormRuleConditionsQuery,
    useCreateFormRuleConditionMutation,
    useUpdateFormRuleConditionMutation,
    useDeleteFormRuleConditionMutation,
    useUpdateAllFormRuleConditionOperationsMutation
} = formRuleConditionsApi;
